import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-trial-remaining-days',
  imports: [RmaIconComponent, RouterModule, TranslocoModule, MatButtonModule],
  providers: [provideTranslocoScope('trialRemainingDays')],
  templateUrl: './trial-remaining-days.component.html',
  styleUrls: ['./trial-remaining-days.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialRemainingDaysComponent {
  public trialDays = input.required<number>();
}
